import DOMPurify from "dompurify";
import { marked } from "marked";
import { localLink } from "./links";

/**
 * Renders assistant output as HTML.
 *
 * The text comes from a model that has read web pages, so it is untrusted by
 * definition: it is sanitised before it ever reaches the DOM. Application
 * links stay in this tab and on this origin; external links open separately.
 */
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    const href = node.getAttribute("href");
    const local = href ? localLink(href) : null;
    if (local) {
      node.setAttribute("href", local);
      node.removeAttribute("target");
      node.removeAttribute("rel");
    } else {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noreferrer noopener");
    }
  }
});

marked.setOptions({ gfm: true, breaks: true });

export function renderMarkdown(text: string): string {
  const html = marked.parse(text ?? "", { async: false });
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      "p", "br", "strong", "em", "del", "code", "pre", "blockquote",
      "ul", "ol", "li", "a", "h1", "h2", "h3", "h4",
      "table", "thead", "tbody", "tr", "th", "td", "hr",
    ],
    ALLOWED_ATTR: ["href", "title", "target", "rel"],
    // http(s) nach draußen — oder ein Pfad auf dieser Anwendung. Letzteres
    // fehlte, und damit fiel jeder Downloadlink auf einen Report auseinander:
    // DOMPurify verwarf das href und ließ ein <a> ohne Ziel stehen, das im
    // Chat aussah wie ein Link und keiner war.
    //
    // `\/(?!\/)` und nicht `\/`: Eine Adresse, die mit zwei Schrägstrichen
    // beginnt, ist protokollrelativ und zeigt auf eine fremde Herkunft —
    // `//example.com` sähe wie ein Pfad aus und wäre keiner.
    //
    // Alles übrige bleibt draußen, `javascript:` und `data:` zuvorderst. Der
    // Text kommt von einem Modell, das Webseiten gelesen hat.
    ALLOWED_URI_REGEXP: /^(?:https?:\/\/|\/(?!\/)|#\/)/i,
  });
}
